import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MyCv from './MyCv';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path='/aboutme' element={<MyCv />} />
      </Routes>
    </BrowserRouter>

  </React.StrictMode>
);